import { route } from '@/utils/build'
const component = path => resolve => require(['@/pages/payment/views/' + path], resolve)

/**
 * 领取权益
 */
export default [
  // 领取权益
  route('/receive', 'receive', component('receive/index'))
]
